import type { AppIconProps } from '../Icons.types';

export const AppScheduleIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;

  return (
    <svg
      {...rest}
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.92878 15.5996H2.26628C1.82425 15.5996 1.40033 15.424 1.08776 15.1115C0.775204 14.7989 0.599609 14.375 0.599609 13.9329V3.93294C0.599609 3.49091 0.775204 3.06699 1.08776 2.75443C1.40033 2.44187 1.82425 2.26628 2.26628 2.26628H12.2663C12.7083 2.26628 13.1322 2.44187 13.4448 2.75443C13.7573 3.06699 13.9329 3.49091 13.9329 3.93294V7.26628H0.599609M10.5996 0.599609V3.93294M3.93294 0.599609V3.93294M13.0996 11.8463V13.0996L13.9329 13.9329M9.76628 13.0996C9.76628 13.9837 10.1175 14.8315 10.7426 15.4566C11.3677 16.0818 12.2156 16.4329 13.0996 16.4329C13.9837 16.4329 14.8315 16.0818 15.4566 15.4566C16.0818 14.8315 16.4329 13.9837 16.4329 13.0996C16.4329 12.2156 16.0818 11.3677 15.4566 10.7426C14.8315 10.1175 13.9837 9.76628 13.0996 9.76628C12.2156 9.76628 11.3677 10.1175 10.7426 10.7426C10.1175 11.3677 9.76628 12.2156 9.76628 13.0996Z"
        stroke="#737781"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
